import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { USER_GROUPS } from '../models/group';
import { VW_MENU_ITEMS } from '../models/menu';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import * as Globals from '../globals';
declare var $: any;

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css']
})
export class GroupComponent implements OnInit {

  userProfile: any;
  groups: USER_GROUPS[];
  menus: VW_MENU_ITEMS[];
  group: USER_GROUPS;
  selectedPa: string;
  authMenu: any;
  loading: boolean = false;
  tab: number = 1;
  grpId: number;
  levGroup: number = 1;
  parts: any[];
  sbn: any[];
  parentGroupId: number;
  groupName: string;
  search: string = '';
  reverse: boolean = false;
  colSort: string[] = ['GROUP_ID'];
  col: number = 0;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
  }
  sort(val: number) {
    if (this.levGroup > 1) {
      this.col = val;
      this.reverse = !this.reverse;
      switch (val) {
        case 1:
          this.colSort = ['GROUP_NAME'];
          break;
        default:
          break;
      }
    }
  }
  ngOnInit() {
    this.parts = [];
    this.group = new USER_GROUPS(0, null, null, 0, 16, '1', null, null, null, 0, false, false, null, null, null);
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.subInit();
    }

  }
  subInit() {
    this.userProfile = this.profileService.userProfile;
    this.authMenu = Globals.getAuthPanel(902, this.userProfile);
    this.grpId = this.userProfile.GROUP_ID;
    if (this.userProfile.GROUP_ID > 1) {
      this.grpId = this.userProfile.PARENT_GROUP_ID;
    }
    this.sbn = [{ ID: 0, TEXT: 'Semua' }, { ID: 1, TEXT: 'SUN' }, { ID: 2, TEXT: 'SBSN' }];
    this.group = new USER_GROUPS(0, null, null, 0, 16, '1', null, null, null, 0, false, false, this.userProfile.USER_ID, null, null);
    this.RefreshData(this.levGroup, this.parentGroupId);
  }
  RefreshData(level: number, id: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/group?cdapp=1&level=' + level + '&parentgroup=' + id + '&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.groups = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  PaChanged(val: string) {
    for (var i = 0; i < this.parts.length; i++) {
      if (this.parts[i].NAME == val) {
        this.group.UD3 = this.parts[i].PA_ID;
        break;
      }
    }
  }
  GetMenu() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/menu?id=' + this.group.GROUP_ID + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.menus = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getParts() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.parts = res.json();
        if (this.parts.length > 0) {
          this.group.UD3 = this.parts[0].PA_ID;
          /*for (var i = 0; i < this.parts.length; i++) {
            if (this.parts[i].PA_ID == this.group.UD3) {
              this.selectedPa = this.parts[i].NAME;
              break;
            }
          }*/
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSubreg() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=2&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.parts = res.json();
        if (this.parts.length > 0) {
          this.group.UD3 = this.parts[0].PA_ID;
          /*for (var i = 0; i < this.parts.length; i++) {
            if (this.parts[i].PA_ID == this.group.UD3) {
              this.selectedPa = this.parts[i].NAME;
              break;
            }
          }*/
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  New() {
    var today = new Date();
    var expDate = new Date();
    expDate.setDate(today.getDate() + 30);
    this.tab = 1;
    this.selectedPa = null;
    this.group = new USER_GROUPS(0, null,null, 0, 16, '1', null, null, null, 0, false, false, this.userProfile.USER_ID,expDate, null);
    if (this.parentGroupId == 3 && this.parts.length == 0) {
      this.getParts();
    }
    if(this.parentGroupId == 9 && this.parts.length == 0 ){
      this.getSubreg();
    }

    //this.GetMenu();
  }
  Edit(group: any) {
    this.group = group;
    var date = new Date(this.group.SD_EXPIRY);
    this.group.D_EXPIRY = date;
    if (this.parentGroupId == 3 && this.parts.length == 0) {
      this.getParts();
    }
    if(this.parentGroupId == 9 && this.parts.length == 0 ){
      this.getSubreg();
    }
    /* if (this.parentGroupId == 3 && this.parts.length > 0) {
      for (var i = 0; i < this.parts.length; i++) {
        if (this.parts[i].PA_ID == this.group.UD3) {
          this.selectedPa = this.parts[i].NAME;
          break;
        }
      }
    }  */
    if (this.levGroup == 1) {
      this.GetMenu();
    }
  }
  Save() {
    this.loading = true;
    this.group.SD_EXPIRY = Globals.formatDateTime(this.group.D_EXPIRY);
    if (this.tab == 1) {
      if (this.userProfile.PA_ID) {
        this.group.UD3 = this.userProfile.PA_ID;
      }
      this.group.CREATED_BY = this.userProfile.USER_ID;
      this.group.UD1 = this.levGroup;
      this.group.PARENT_GROUP_ID = this.parentGroupId;
      if (this.group.UD1 == 1 || this.group.PARENT_GROUP_ID == 4) {
        this.group.MULTIPLE = true;
      }
      if (this.group.GROUP_ID == 0) {
        this.http.post(Globals.serviceUrl + 'ref/group', this.group, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.group = res.json();
            if (this.group.GROUP_ID == -1) {
              if (this.group.PARENT_GROUP_ID == 3) {
                this.toastr.error('Group untuk agen penjual ' + this.selectedPa + ' sudah ada.');
              } else {
                this.toastr.error('Group sudah ada.');
              }
              $('#modal').modal('hide');
              this.RefreshData(this.levGroup, this.parentGroupId);

            } else {
              if (this.group.PARENT_GROUP_ID == 4) {
                this.parentGroupId = 5;
                this.Save();
              } else {
                this.toastr.success('Data berhasil disimpan');
                $('#modal').modal('hide');
                if (this.parentGroupId == 5) {
                  this.parentGroupId = 4;
                }
                this.RefreshData(this.levGroup, this.parentGroupId);
              }
            }

          }, err => {
            console.log(err);
            if (err.status == 400) {
              this.toastr.error(err.json().Message);
            } else {
              this.toastr.error(Globals.errorMessage(err));
            }
            this.loading = false;
          });
      } else {
        this.http.put(Globals.serviceUrl + 'ref/group?id=' + this.group.GROUP_ID, this.group, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            if (this.levGroup > 1) {
              this.group = res.json();
              $('#modal').modal('hide');
            }
            this.toastr.success('Data berhasil disimpan');
            this.RefreshData(this.levGroup, this.parentGroupId);
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
    } else {
      this.http.put(Globals.serviceUrl + 'ref/menu?id=' + this.group.GROUP_ID, this.menus, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.GetMenu();
          this.loading = false;
          this.toastr.success('Data berhasil disimpan');
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  Delete() {
    this.loading = true;
    this.http.delete(Globals.serviceUrl + 'ref/group?id=' + this.group.GROUP_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.RefreshData(this.levGroup, this.parentGroupId);
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  rChange(idx: number, event: any) {
    this.menus[idx].R_FLAG = event.target.checked;
    if (!event.target.checked) {
      this.menus[idx].M_FLAG = false;
      this.menus[idx].D_FLAG = false;
    }
  }
  mChange(idx: number, event: any) {
    this.menus[idx].M_FLAG = event.target.checked;
    if (!this.menus[idx].D_FLAG) {
      this.menus[idx].R_FLAG = event.target.checked;
    }
  }
  dChange(idx: number, event: any) {
    this.menus[idx].D_FLAG = event.target.checked;
    if (!this.menus[idx].M_FLAG) {
      this.menus[idx].R_FLAG = event.target.checked;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/group/group.component.ts